<template>
   <HeaderTrade />

      <!-- Container Start { -->
      <div id="container" class="sts-trade-container">
        <!-- Contents Start { -->
        <div id="contents">

          <TradeTopNav 
           :pid="route.params.id"
          />
          
          <!-- content start -->
          <div class="contents-area">
            
            <!-- 좌측 : 종목 조회 start -->
            <div class="trade-search-area" id="tradeSearchArea">
              <table class="trade-search">
                <tr>
                  <td colspan="2" class="search-input">
                    <div class="input">
                      <input 
                                type="text" 
                                class="form-control"
                                placeholder="종목명/코드 검색"
                                v-model="searchText"
                                @keyup="onKeyup"
                                @focus="onFocus"
                      >
                      <button v-if="!searchText" class="btn-search" type="button"><img src="@/assets/images/common/ico_header_search.png" alt="search"></button>  
                      <button v-else class="btn-cancel" type="button" ><img src="@/assets/images/common/ico_close.png" alt="cancel"   @click="onSearchDel"></button>                                 
                    </div>
                  </td>
                </tr>
              </table>

              <div class="trade-search-result">
                <div class="trade-search-tab">
                  <!-- tab button -->
                  <ul class="nav nav-tabs nav-fill" id="tradeSearchTabButton" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link" :class="currentMode=='normal'?'active':''"  id="trade-search-won-tab" data-bs-toggle="tab"  type="button" role="tab" aria-controls="tradeSearchWonTab"  @click ="onTapClicked('normal')">
                        전체종목
                      </button>
                    </li>
              
                    <li class="nav-item" role="presentation">
                      <!-- <button class="nav-link active" id="trade-search-interest-tab" data-bs-toggle="tab"  type="button" role="tab" aria-controls="tradeSearchInterestTab" aria-selected="true" @click="onFavorTapClickd"> -->
                      <button class="nav-link" :class="currentMode=='favor'?'active':''"  id="trade-search-interest-tab" data-bs-toggle="tab"  type="button" role="tab" aria-controls="tradeSearchInterestTab"  @click ="onTapClicked('favor')">
                        관심종목
                      </button>
                    </li>
                  </ul>
    
                  <!-- tab contents -->
                  <div class="tab-content" id="tradeSearchTabContents">
    
                    <!-- 원화마켓 start -->
                    <div class="tab-pane" :class="currentMode=='normal'?'active':''"  id="tradeSearchWonTab" role="tabpanel" aria-labelledby="trade-search-won-tab">
                      <!-- <div class="trade-search-null" style="display:none;">데이터를 가져오지 못했습니다.<br>새로고침하여 주십시오.</div> -->

                      <!-- 원화마켓 상단 시작  -->
                      <div class="trade-search-summary">
                        <table class="table">
                          <colgroup>
                            <col style="width:40px">
                            <col style="width:50%">
                            <col style="width:40%">
                            <!-- <col style="width:75px">
                            <col style="width:95px"> -->
                          </colgroup>
                          <tr>
                            <th colspan="2">
                              <button type="button" class="btn">
                                종목
                                <!-- <span class="ico"><img src="@/assets/images/trade/search_change.png" alt="한글명"></span> -->
                              </button>
                            </th>
                            <th>
                              <button type="button" class="btn btn-sort-arrow">
                                코드
                                <!-- <span class="ico"><i class="sort"></i></span> -->
                              </button>
                            </th>
                            <!-- <th>
                              <button type="button" class="btn btn-sort-arrow">
                                전일대비
                                <span class="ico"><i class="sort"></i></span>
                              </button>
                            </th>
                            <th>
                              <button type="button" class="btn btn-sort-arrow">
                                거래대금
                                <span class="ico"><i class="sort"></i></span>
                              </button>
                            </th> -->
                          </tr>
                        </table>
                      </div>
                      <!-- //원화마켓 상단 종료 -->

                      <!-- 원화마켓 내용 start -->
                    <div v-if="!filteredItems.length" class="trade-search-null">
                        검색된 아이템이 없습니다.
                    </div>
                      <perfect-scrollbar 
                        @ps-scroll-y="onScroll" 
                        :options="options"
                        :watch-options="watcher"
                        ref="scrollbar"
                        class="trade-search-won" id="tradeSearchWon"
                      >

                        <table class="table">
                          <colgroup>
                            <col style="width:40px">
                            <col style="width:50%">
                            <col style="width:40%">
                          </colgroup>
                          <tbody>

                            <tr 
                               v-for="(item, index) in filteredItems"                     
                               :key = index          
                            >
                              <td>
                                <button  @click="onFavorClick(item, $event)" type="button" class="btn btn-favor" :class="item._isFavor?'on':''">관심종목</button>      
                              </td>
                              <td>             
                                <a @click="onItemClick(item, $event)" href="javascript:;" class="searchSelectBorded"  :class="currentItem.KORNAME == item.KORNAME?'selected':''">
                                  {{ item.NAME }}
                                </a>                  
                              </td>
                              <td>
                                <a @click="onItemClick(item, $event)" href="javascript:;" class="searchSelectBorded"  :class="currentItem.KORNAME == item.KORNAME?'selected':''">
                                  {{item.CODE}}
                                </a>
                              </td>                 
                            </tr>
                
                          </tbody>
                        </table>
                      </perfect-scrollbar>
                      <!-- //원화마켓 내용 end -->
                      
                    </div>
                    <!-- //원화마켓 end -->
    
                    
                    <!-- 관심코인 start -->
                    <div class="tab-pane" :class="currentMode=='favor'?'active':''"   id="tradeSearchInterestTab" role="tabpanel" aria-labelledby="trade-search-interest-tab">

                      <!-- 관심코인 상단 시작  -->
                      <div class="trade-search-summary">
                        <table class="table">
                          <colgroup>
                            <col style="width:40px">
                            <col style="width:50%">
                            <col style="width:40%">
                            <!-- <col style="width:75px">
                            <col style="width:95px"> -->
                          </colgroup>
                          <tr>
                            <th colspan="2">
                              <button type="button" class="btn">
                                종목
                                <!-- <span class="ico"><img src="@/assets/images/trade/search_change.png" alt="한글명"></span> -->
                              </button>
                            </th>
                            <th>
                              <button type="button" class="btn btn-sort-arrow">
                                코드
                                <!-- <span class="ico"><i class="sort"></i></span> -->
                              </button>
                            </th>                      
                          </tr>
                        </table>
                      </div>
                      <!-- //관심코인 상단 종료 -->

                      <!-- 관심코인 내용 start -->
                      <div v-if="!favorItemList.length"  class="trade-search-null">
                        관심종목이 없습니다.
                      </div>

                      <div v-else-if="!filteredItems_favor.length" class="trade-search-null">
                        검색된 아이템이 없습니다.
                      </div>
                      <!-- <div class="trade-search-interest" id="tradeSearchInterest"> -->
                      <perfect-scrollbar 
                        @ps-scroll-y="onScroll" 
                        :options="options"
                        :watch-options="watcher"
                        ref="scrollbar"
                        class="trade-search-interest" id="tradeSearchInterest"
                      >
                        <table class="table">
                          <colgroup>
                            <col style="width:40px">
                            <col style="width:50%">
                            <col style="width:40%">
                          </colgroup>
                          <tbody>
                
                             <tr 
                               v-for="(item, index) in filteredItems_favor"                     
                               :key = index                                                     
                              >
                              <td>
                                 <button  @click="onFavorClickInFavor(item)" type="button" class="btn btn-favor " :class="item._isFavor?'on':''">관심종목</button>
                              </td>
                              <td>
                                <a @click="onItemClick(item, $event)"    href="javascript:;" class="searchSelectBorded"  :class="currentItem.KORNAME == item.KORNAME?'selected':''">
                                  {{ item.NAME }}
                                </a>
                              </td>
                              <td>
                                <a @click="onItemClick(item, $event)" href="javascript:;" class="searchSelectBorded"  :class="currentItem.KORNAME == item.KORNAME?'selected':''">
                                  {{item.CODE}}
                                </a>
                              </td>                 
                            </tr>
           
                          </tbody>
                        </table>
                      </perfect-scrollbar>
                      <!-- </div> -->
                      <!-- //관심코인 end -->

                    </div>
                    <!-- //관심코인 end -->
    
                  </div>
                </div>
              </div>

            </div>
            <!-- //좌측 : 종목 조회 end -->

          </div>
          <!-- // content end -->

          <TradeBottomNav 
           :id="route.params.id"
          />

        </div>
        <!-- } Contents End -->
      </div>
      <!-- } Container End -->


</template>

<script>
import { useRouter, useRoute}from 'vue-router'
import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import TradeTopNav from "@/components/TradeTopNav.vue"
import TradeBottomNav from "@/components/TradeBottomNav.vue"
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import Constant from '@/constant.js';
import {useApicall} from '@/composables/commonFn';
//import { useScoket } from '@/socket';
import {ref, getCurrentInstance, onMounted, onUnmounted, computed,  watch} from 'vue';
import {useGetItemList, useSpaceId} from '@/composables/vtradeFn';
//import Config from '../../../public/config.js';

export default {
    components:{   
        HeaderTrade,
        TradeTopNav,
        TradeBottomNav,
        PerfectScrollbar
    },
    setup(){
        const store = useStore();
        const route = useRoute();
        store.commit('trade/CHANGE_CURRENT_PAGE_BOTTOM', 'itemList'); 
        //const  trace = getCurrentInstance().appContext.config.globalProperties.$log;
        const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;
        const router = useRouter();
        const  {getItemListBySessionStorage} = useGetItemList()
        const refItems = ref([]);
      
        const {setCurrentSpaceId, setCurrentSpaceIdForEvent} = useSpaceId();


        const routeId = computed(()=> route.params.id )
        watch(routeId,()=>{           
            if(route.params.id != '0')window.location.reload();    
        })
        
        //console.log("!!!!tradeItemStockFutures", route.params.type)
        store.commit('hts/CHANGE_TRADE_TYPE',  'S');
        store.commit('common/CHANGE_CURRENT_PAGE', "TradeStock"); 
        store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_0'); 

       
        emitter.on('EVENT_INIT_TRADE_FOR_SPACE', (obj) => {
          emitter.off('EVENT_INIT_TRADE_FOR_SPACE');      
                       
          if(obj == null)
          {
            store.commit('hts/CHANGE_SPACE_ID', -1);
          }
          else
          {
            store.commit('hts/CHANGE_SPACE_ID', obj.id);         
           // setCurrentBalance(obj.id);        
          }       
        })

        var ispossibleSelect = true;
        const {apiCall_pt, apiCall_gt} = useApicall();
        const currentItem = ref({});
        const scrollbar = ref(null);
        const searchText = ref('');
        const scrollTop = ref(0);
      
        const currentMode = ref('normal');
        // if(route.query && route.query.favor)
        // {
        //   currentMode.value = "favor";
        // }

 
 

        const isLogin = computed(() => store.state.user.isLogin);
        const tradeType = computed(() => store.state.hts.currentTradeType);

        if(route.params.id == '0') 
        {
          store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'normal');
          setCurrentSpaceId(tradeType.value);  
        }
        else
        {
          store.commit('trade/CHANGE_CURRENT_LEAGUETYPE', 'event');
          setCurrentSpaceIdForEvent(tradeType.value, route.params.id);
        }

       // setCurrentSpaceId(tradeType.value);
        const favorItemList = ref([]);
        const filteredItems = computed(()=>{
          if(searchText.value){
              return refItems.value.filter(item => {
                   return  item.NAME.toLowerCase().includes(searchText.value.toLowerCase()) || item.CODE.toLowerCase().includes(searchText.value.toLowerCase());
              })
          }
          return   refItems.value.slice(0, getSliceItemsLength(scrollTop.value))    
        });

        const filteredItems_favor = computed(()=>{
          if(searchText.value){
              return favorItemList.value.filter(item => {                  
                   return  item.NAME.toLowerCase().includes(searchText.value.toLowerCase()) || item.CODE.toLowerCase().includes(searchText.value.toLowerCase());
              })
          }
          return favorItemList.value;
        });

        watch(isLogin, async ()=>{
             console.log("isLogin :",isLogin.value )
             await  setCurrentSpaceId(tradeType.value);
             getFavorItemList()
        })

        //const { emit } = getCurrentInstance();
       const getSliceItemsLength = (scrollTop) => {
         // console.log("scrollTop :", scrollTop)
          var spliceArrNum = 0;
          var MAXSCROLLTOP = 101267;


          if(refItems.value.length == 0)return 0;          
          var addItemNum = refItems.value.length / 5;
          for(var i=5; i>0; i--)
          {           
            if(scrollTop < (MAXSCROLLTOP / i))
            {
                spliceArrNum =  parseInt(addItemNum * (6 - i)) + 100;             
                break;
            }
          }
         // console.log("spliceArrNum :", spliceArrNum)
          return spliceArrNum
         
       }

        const goLoginPage=()=>{
          //location.href = Config.URL.flexLifeUrl + `login?app=money&redirect_url=${Config.URL.flexMoneyUrl}`;
          location.href = process.env.VUE_APP_flexTvUrl + `partner/money/signin?&callbackUrl=${process.env.VUE_APP_flexMoneyUrl}`;
        }


        const onItemClick = (item) =>{
        
            if(!ispossibleSelect) return;
            ispossibleSelect = false;
            if(!isLogin.value)
            {
              emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
              return;
            }
            setTimeout(()=>{
                 ispossibleSelect = true;
            }, 2000)
            currentItem.value = item; 
            sessionStorage.setItem(`startItem_S`, JSON.stringify(item));              
            //emit('onSelectItem',item)

            router.push({
              name: 'TradeArea',
              params: {
                code:item.CODE,      
                id:route.params.id           
              }
           }) 

      

        }




        const addFavorList = async(_accountId, _tradeType, _code) =>{
          var params =   {
              "accountId": _accountId,
              "type": _tradeType,
              "code": _code
          }

          var res = await apiCall_pt(`vspace/favorateitemregister`, params, null, (message)=>{
            emitter.emit('EVENT_ALERT',{title:"알림", body:message});
          });
         // console.log("addFavorList: ", res)
          if(!res)return false   
          sessionStorage.setItem(`getfavor_${store.state.hts.currentAccountId}_${tradeType.value}`, null) 
          return true;
        }




        const removeFavorList = async(_code) =>{
            var params =   {
                "code": _code,
                "accountId":store.state.hts.currentAccountId
            }

            var res = await apiCall_pt(`vspace/favorateitemdelete`, params, null, (message)=>{
              emitter.emit('EVENT_ALERT',{title:"알림", body:message});
            });

            if(!res)return
            sessionStorage.setItem(`getfavor_${store.state.hts.currentAccountId}_${tradeType.value}`, null) 
            return true;
        }

        const onFavorClickInFavor = async(item) =>{
          if(await removeFavorList(item.CODE))
          {
             emitter.emit('EVENT_ALERT',{title:"알림", body:"관심종목에서 삭제되었습니다."});
             getFavorItemList();
              var found =  refItems.value.find(element => element.CODE == item.CODE);
              
              if(found)
              {                 
                found._isFavor = false;               
                    
              }

          }
        }


        const onFavorClick = async (item, e) =>{
          // console.log("onFavorClick:", item,  e.target.classList.contains('on'))
           if(!isLogin.value)
            {
              emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
              return;
            }


          if(e.target.classList.contains('on'))
          {
              //관심종목 지움
              
              if(await removeFavorList(item.CODE))
              {
                  item._isFavor = false;
                   //e.target.classList.remove('on');
                     emitter.emit('EVENT_ALERT',{title:"알림", body:"관심종목에서 삭제되었습니다."});
              }
              else
              {
                  // e.target.classList.add('on');
                    item._isFavor = true;
              }

          }
          else
          {          
            
              //관심종목 추가
              if(!store.state.hts.currentAccountId)
              {
                emitter.emit('EVENT_ALERT',{title:"알림", body:"대회 참가후 사용가능합니다."});
                return;
              }
               
              if(await addFavorList(store.state.hts.currentAccountId, tradeType.value, item.CODE))
              {
                

                  item._isFavor = true;
                 //  e.target.classList.add('on');
                  emitter.emit('EVENT_ALERT',{title:"알림", body:"관심종목에 추가되었습니다."});
                   
              }
              else
              {
                 item._isFavor = false;
                //   e.target.classList.remove('on');
                 
              }
              
          }
          
         // e.target.classList.toggle('on');
         // e.target.classList.remove('on');
        }

       // const periodInitData = computed(()=>store.state.hts.periodInitData);

      const getFavorItemList = async() =>{
        favorItemList.value = [];
        if(!isLogin.value) return false;
        var res = JSON.parse(sessionStorage.getItem(`getfavor_${store.state.hts.currentAccountId}_${tradeType.value}`));  
        if(!res)
        {
            res = await apiCall_gt(`vspace/getfavorateitemlist?accountId=${store.state.hts.currentAccountId}&type=${tradeType.value}`);
            sessionStorage.setItem(`getfavor_${store.state.hts.currentAccountId}_${tradeType.value}`, JSON.stringify(res)); 
        }


        if(!res) return false;
        favorItemList.value = res.favorateList;
         //console.log("_isFavor", favorItemList.value)
        if(!favorItemList.value)favorItemList.value =[];
        favorItemList.value.forEach(_element => {           
            _element._isFavor = true;
            var found =  refItems.value.find(element => element.CODE == _element.CODE);
                   
            if(found)
            {
                found._isFavor = true;            
                        
            }
        });
      }
   
       onMounted( async ()=>{
        refItems.value = await getItemListBySessionStorage(tradeType.value)   
      
          
        setTimeout(getFavorItemList, 1000)        
       })
       
       
       onUnmounted(()=>{
       })

  

        const onFocus = (e) =>{
            console.log("onFocus", e)  
        }

        const onKeyup =(e)=>{
         if(e.keyCode == 13)
         {             
             scrollbar.value.$el.scrollTop = 0;
         }
        }
        

        const onSearchDel = ()=>{
          searchText.value = ''
        }

        const onScroll = (e) =>{
       
           //  console.log(e.target.scrollTop); 
             scrollTop.value = e.target.scrollTop;
        }

        const onTapClicked = (_status)=>{
           currentMode.value = _status;
       
          if(_status == 'favor')
          {           
            getFavorItemList();
          }     
        }


    return{

           options: {       
                wheelSpeed: 1,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollX: false,
            },
            watcher: true,
            onScroll,
            scrollbar,
           
            onItemClick,
            onFavorClick,
            currentItem,
            Constant,
            searchText,
            onKeyup,
            onFocus,
            filteredItems,
            favorItemList,
           // onFavorTapClickd,
            onSearchDel,
            onFavorClickInFavor,
            filteredItems_favor,
           
            refItems,
            tradeType,
            onTapClicked,
            currentMode,
          
            route
           
    }
  }
}
</script>

<style>

</style>